export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  WontSpecify = 'WONT_SPECIFY'
}
